// Hobbies.js
import React from 'react';
import HobbiesPage from './HobbiePage';
const Hobbie = () => {
  return (
    <div>

      <a href="#Hobbies" style={{ textDecoration: 'none' }}> < HobbiesPage /></a>
    </div>
  );
};

export default Hobbie;
